import React from "react";

/**
 * DropdownButton component
 * @param {Object} props - The properties passed to the component
 * @param {string} props.buttonText - The text to be displayed on the button
 * @param {ReactNode} props.child - The child elements to be displayed in the dropdown menu
 * @param {string} props.buttonId - The id for the button, used for associating the dropdown menu with the button
 * @param {...Object} props - The rest of the properties are spread onto the button element
 */
const DropdownButton = ({ buttonText, child, buttonId, ...props }) => (
  <div className="dropdown d-flex">
    <button
      className="btn btn-sm btn-primary float-right dropdown-toggle d-flex justify-content-center align-items-center"
      type="button"
      id={buttonId}
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      {...props}
    >
      {buttonText}
    </button>
    <div
      style={{ padding: 0 }}
      className="dropdown-menu"
      aria-labelledby={buttonId}
    >
      {child}
    </div>
  </div>
);

export default DropdownButton;
